import React, { useState, useContext } from 'react';
import { v4 as uuid } from 'uuid';
import { ListGroupItem, Collapse, Button, Input, Form } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClock, faUsers, faSpinner } from '@fortawesome/free-solid-svg-icons';

import TaskRegistration from './TaskRegistration';
import { AuthContext } from '../../../../../Data/AuthContext';
import { taskStateToString } from '../../../../../Utils/Converters';


import './Task.css';
import Axios from 'axios';
import { toast } from 'react-toastify';

function Task(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [remark, setRemark] = useState('');
    const auth = useContext(AuthContext);

    const { id, eventId, name, neededPeople, deadline, state, registrations, description } = props;

    const registration = registrations.find(r => r.userId === auth.userId);

    function onSubmit(e) {
        e.preventDefault();
        Axios.post(`/events/${eventId}/tasks/${id}/registrations`, {remark})
            .then(res => {
                toast.success('Jelentkezés mentve.');
                props.callback();
            }, err => {
                    console.log(err);
                toast.error(`A jelentkezés mentése sikertelen. ${Object.values(err.errors).join()}`);
            });
    }

    return (
        <ListGroupItem className="Task">
            <span onClick={() => setIsOpen(!isOpen)} className="header">
                <div className="task-title">{name}</div>
                <FontAwesomeIcon icon={faUsers} /> {registrations.length}/{neededPeople} fő
                &nbsp;&nbsp;&nbsp; <FontAwesomeIcon icon={faClock} /> {new Date(deadline).toLocaleString("hu")}
                &nbsp;&nbsp;&nbsp; <FontAwesomeIcon icon={faSpinner} /> {taskStateToString(state)}
            </span>
            <Collapse isOpen={isOpen}>
                <div dangerouslySetInnerHTML={{ __html: description }} />
                {registrations.length > 0 && "Jelentkezők:"}
                {registrations.map(r => <TaskRegistration taskReg={r} key={uuid()} callback={props.callback} />)}
                {!registration && <Form onSubmit={onSubmit} id={`taskRegistrationForm_${id}`}>
                    <Input type="text" placeholder="Megjegyzés" className="col-md-4 mx-auto" value={remark} onChange={e => setRemark(e.target.value)} />
                    <Button color="primary" type="submit"><FontAwesomeIcon icon={faCheck} /> Jelentkezés</Button>
                </Form>}
            </Collapse>
        </ListGroupItem>
    );
}

export default Task;